module.exports = __webpack_public_path__ + "img/landing-woman.70d4d7a6.png";